// extracted by mini-css-extract-plugin
export default {"loaderContainer":"src-client-theme-screens-subscription-cancellation-redirect-___default__loaderContainer___FnvGZ"};